import { ConfigService } from '@config/config.service';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { UserAddressListResponse } from '@services/back-office/model/userAddressListResponse';
import { UserAddressSearchRequest } from '@services/back-office/model/userAddressSearchRequest';
import { PaginationModel } from '@shared/models/pagination.model';
import { RequestsActions, RequestsActionTypes } from '@support/ngrx/actions/requests.actions';


export const adapter: EntityAdapter<UserAddressListResponse> = createEntityAdapter<UserAddressListResponse>();

export interface State extends EntityState<UserAddressListResponse> {
  loading: boolean,
  pagination: PaginationModel,
  filter: UserAddressSearchRequest,
}

export const initialState: State = adapter.getInitialState({
  loading: false,
  pagination: {
    first: true,
    last: false,
    number: 0,
    numberOfElements: 0,
    size: new ConfigService().paginationConfig.pageSize,
    totalElements: 0,
  },
  filter: {},
});

export function reducer(state = initialState, action: RequestsActions): State {
  switch (action.type) {
    /** Load Requests */
    case RequestsActionTypes.LoadRequests:
      return {...state, loading: !action.payload?.dontShowLoading};

    case RequestsActionTypes.LoadRequestsSuccess:
      return adapter.setAll(action.payload.content!, {
        ...state,
        loading: false,
        pagination: {
          size: action.payload.size,
          last: action.payload.last,
          totalElements: action.payload.totalElements,
          numberOfElements: action.payload.numberOfElements,
          first: action.payload.first,
          number: action.payload.number,
        },
      });

    case RequestsActionTypes.LoadRequestsFailure:
      return {...state, loading: false};

    /** Set In Progress Request */
    case RequestsActionTypes.SetInProgressRequests:
      return {...state};

    case RequestsActionTypes.SetInProgressRequestsSuccess:
      if (action.payload.id) {
        return adapter.updateOne({
          id: action.payload.id!,
          changes: action.payload,
        }, {
          ...state,
        });
      } else {
        return adapter.removeOne(action.payload.id!, {...state});
      }

    case RequestsActionTypes.SetInProgressRequestsFailure:
      return {...state};

    /** Change Page */
    case RequestsActionTypes.ChangePage:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          number: action.payload.number,
          size: action.payload.size,
        }
      };

    /** Set Initial Pagination */
    case RequestsActionTypes.SetInitialPagination:
      return {...state, pagination: initialState.pagination};

    /** Set Filter */
    case RequestsActionTypes.SetFilter:
      return {...state, filter: action.payload};

    /** Clear Filter */
    case RequestsActionTypes.ClearFilter:
      return {...state, filter: initialState.filter};

    /** Set Initial State */
    case RequestsActionTypes.SetInitialState:
      return {...initialState};

    default:
      return state;
  }
}

export const {
  selectIds: selectRequestsIds,
  selectEntities: selectRequestsEntities,
  selectAll: selectAllRequests,
  selectTotal: selectRequestsTotal,
} = adapter.getSelectors();
